module.exports = new __parcel__URL__("losangeles_banner.26c79e9c.png").toString();